import React from "react";
import Icon from "components/AppIcon";
import Button from "components/ui/Button";

export default function ExportModal({ spv, onClose }) {
  return (
    <div
      className="fixed inset-0 flex items-center justify-center p-4"
      style={{ zIndex: "var(--z-modal)", background: "rgba(15,20,25,0.6)" }}
      onClick={onClose}
    >
      <div
        className="bg-card rounded-xl shadow-xl w-full max-w-lg"
        onClick={(e) => e?.stopPropagation()}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-5 border-b border-border">
          <div className="flex items-center gap-3">
            <div
              className="w-9 h-9 rounded-lg flex items-center justify-center"
              style={{ background: "rgba(59,76,76,0.1)" }}
            >
              <Icon name="FileText" size={18} color="var(--color-primary)" />
            </div>
            <div>
              <h2 className="font-heading text-base font-semibold text-foreground">SPV Report Preview</h2>
              <p className="font-caption text-xs text-muted-foreground">{spv?.name}</p>
            </div>
          </div>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-muted transition-all duration-200"
          >
            <Icon name="X" size={16} color="var(--color-muted-foreground)" />
          </button>
        </div>

        {/* PDF Preview Mock */}
        <div className="p-5">
          <div
            className="rounded-lg border border-border p-5 space-y-4"
            style={{ background: "var(--color-background)" }}
          >
            <div className="flex items-center justify-between border-b border-border pb-3">
              <div>
                <p className="font-heading text-sm font-semibold text-foreground">{spv?.name}</p>
                <p className="font-caption text-xs text-muted-foreground">Investor Report · {new Date()?.toLocaleDateString("en-GB")}</p>
              </div>
              <div
                className="w-8 h-8 rounded flex items-center justify-center"
                style={{ background: "var(--color-primary)" }}
              >
                <Icon name="Landmark" size={14} color="white" />
              </div>
            </div>

            {[
              { label: "Total Commitments", value: "£42.5m" },
              { label: "Capital Called", value: "£28.3m" },
              { label: "Distributions", value: "£3.1m" },
              { label: "Current IRR", value: "11.4%" },
              { label: "MOIC", value: "1.18×" },
              { label: "Investors", value: "7" },
            ]?.map((row) => (
              <div key={row?.label} className="flex items-center justify-between">
                <span className="font-caption text-xs text-muted-foreground">{row?.label}</span>
                <span className="font-data text-sm font-semibold text-foreground">{row?.value}</span>
              </div>
            ))}

            <div className="border-t border-border pt-3">
              <p className="font-caption text-xs text-muted-foreground text-center">
                Confidential · SeedDrive Infrastructure Equity · FCA Regulated
              </p>
            </div>
          </div>
        </div>

        <div className="flex items-center justify-end gap-2 px-5 pb-5">
          <Button variant="outline" size="sm" onClick={onClose}>Cancel</Button>
          <Button variant="default" size="sm" iconName="Download" iconPosition="left" iconSize={14} onClick={onClose}>
            Download PDF
          </Button>
        </div>
      </div>
    </div>
  );
}